import SurveyAnswer from '../../../../shared/models/survey/SurveyAnswer';
import SurveyQuestion from '../../../../shared/models/survey/SurveyQuestion';
import SurveyQuestionMultipleChoice from '../../../../shared/models/survey/SurveyQuestionMultipleChoice';
import SurveyQuestionNumericInput from '../../../../shared/models/survey/SurveyQuestionNumericInput';
import SurveyQuestionNumericSlider from '../../../../shared/models/survey/SurveyQuestionNumericSlider';
import SurveyQuestionType from '../../../../shared/models/survey/SurveyQuestionType';
import useSurveyContext from '../../../survey/store/UseSurveyContext';
import Habit from './Habit';
import HabitType from './HabitType';
import { HabitNumericInputDetails, HabitRadioDetails, HabitSliderDetails } from './types';

type PropType = {
  question: SurveyQuestion;
  setQuestionAnswer: (questionAnswer: SurveyAnswer) => void;
};

const HabitRenderer = ({ question, setQuestionAnswer }: PropType) => {
  const { questionAnswers } = useSurveyContext();

  const getCurrentValue = (questionId: string) => {
    const q = questionAnswers.find((answer) => {
      const { questionId: answerQuestionId } = answer;
      return answerQuestionId === questionId;
    });

    if (q !== undefined) {
      const { value } = q;

      if (Array.isArray(value)) {
        return value[0];
      }

      return value;
    }

    return false;
  };

  const { questionId, questionType, title } = question;
  const currentValue = getCurrentValue(questionId);

  let valueDetails: HabitSliderDetails | HabitRadioDetails | HabitNumericInputDetails = {
    minValue: 0,
    maxValue: 10,
    currentValue: 0,
    questionKey: questionId,
    allowDecimals: false,
  };

  let type = HabitType.INPUT;

  if (questionType === SurveyQuestionType.NUMERIC_SLIDER) {
    const { max, min } = question as SurveyQuestionNumericSlider;
    valueDetails = {
      minValue: min,
      maxValue: max,
      currentValue: currentValue as number,
      step: 1,
      questionKey: questionId,
      allowDecimals: false,
    };
    type = HabitType.SLIDER;
  }

  if (questionType === SurveyQuestionType.MULTIPLE_CHOICE) {
    const { options } = question as SurveyQuestionMultipleChoice;
    valueDetails = {
      options,
      questionKey: questionId,
      currentValue: currentValue as string,
    };
    type = HabitType.RADIO;
  }

  if (questionType === SurveyQuestionType.NUMERIC_INPUT) {
    const { max, min, identifier } = question as SurveyQuestionNumericInput;

    const decimalAllowedIdentifiers = ['IntensiveExercise', 'ModerateExercise'];
    const allowDecimals = decimalAllowedIdentifiers.includes(identifier);

    valueDetails = {
      minValue: min,
      maxValue: max,
      currentValue: currentValue as number,
      questionKey: questionId,
      allowDecimals: allowDecimals as boolean,
    };
    type = HabitType.INPUT;
  }

  return (
    <Habit
      key={questionId}
      onChange={(answer: SurveyAnswer) => {
        setQuestionAnswer(answer);
      }}
      questionId={questionId}
      title={title}
      type={type}
      valueDetails={valueDetails}
    />
  );
};

export default HabitRenderer;
